//
//

import { mapMutations, mapGetters, mapActions } from "vuex";
import ApplicationsPage from "@/components/apps/applicationsPage/applicationsPage.vue";
import SharedApplications from "@/components/apps/sharedApplications/sharedApplications.vue";
import ArchivedApplications from "@/components/apps/archivedApplications/archivedApplications.vue";
import NoAppsPage from "@/components/apps/noAppsPage/noAppsPage.vue";
import AQLeftSideBar from "@/components/Generics/AQLeftSideBar/AQLeftSideBar.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AppsMainPage from "@/components/apps/appsMainPage/appsMainPage.vue";
import { eventBus } from "@/assets/js/appFunc";

export default {
    name: "Home",
    components: {
        ApplicationsPage,
        SharedApplications,
        ArchivedApplications,
        NoAppsPage,
        AppsMainPage,
        AQLeftSideBar,
        AQButton
    },
    data() {
        return {
            pageName: "Home",
            isActive: true,
            sharedAppsNumber: false,
            archivedAppsNumber: false,
            noApps: true,
            hideCreateAppBtn: false,
            searchObject: {
                page: 0,
                search: "",
                ids: []
            }
        };
    },

    computed: {
        ...mapGetters("apps", ["allAppsNumber"])
    },

    created() {
        this.sharedAppsNumber = this.$router.currentRoute.name === "SharedApplications";
        this.archivedAppsNumber = this.$router.currentRoute.name === "ArchivedApplications";
        this.$root.$on("existApps", () => {
            this.noApps = false;
        });
        this.$root.$on("hideCreateBtn", value => {
            this.hideCreateAppBtn = value;
        });
    },
    activated() {
        this.isActive = true;
        if (!this.$route.params.applicationId && this.$route.name !== "AddToArchive") {
            this.$store.commit("apps/setCurrentApp", {});
        }
    },
    mounted() {
        eventBus.$on("appSearch", searchText => {
            this.searchObject.search = searchText;
            this.searchObject.page = 0;
            this.searchObject.ids = [];
            this.$store.commit("apps/resetPagedApps");
            const query = searchText ? { search: searchText } : {};
            if (this.isActive) {
                this.$router.replace({ path: "/applications", query });
            }
            this.getPagedApps(this.searchObject).then(() => {
                this.$root.$emit("applicationsLoaded");
            });
        });
    },
    deactivated() {
        this.isActive = false;
    },
    methods: {
        ...mapMutations("apps", ["setCurrentApp", "resetPagedApps"]),
        ...mapActions("apps", ["getAllApps", "getAppsNumber", "getPagedApps"])
    }
};
